<!--登录注册 -->
<template>
  <div class="centerBox">
    <div class="left">
      <div :style="logoStyle"></div>
      <div class="supgate">{{logo.protal}}</div>
    </div>

    <div class="topa" style="margin-right:15px">
      <a class="register" href="#" v-on:click="regclick" @click="noneshow()">{{syzcName}}</a>
      <span class="column">|</span>
      <a class="forget" href="#" v-on:click="show2 = !show2" @click="noneshow()">{{sywjName}}</a>
      <button class="login" id="login" :style="login" @click="addLogin()">{{loginName}}</button>

      <!-- 多语言切换 -->
      <img style="margin-right:2px;" src="img/1x.png" />
      <!-- <el-select class="language" v-model="number" :style="multilingual" placeholder="请选择" @change="getValue">
        <el-option
          v-for="dict in languageOptions"
          :key="dict.number"
          :label="dict.name"
          :value="dict.number"
        ></el-option>
      </el-select>-->
      <!-- <el-dropdown @command="getValue" trigger="click">
  <span class="el-dropdown-link">
    {{number}}
  </span>
  <el-dropdown-menu slot="dropdown">
    <el-dropdown-item :command= "zh_TW_number">{{zh_TW}}</el-dropdown-item>
    <el-dropdown-item :command= "en_US_number">{{en_US}}</el-dropdown-item>
    <el-dropdown-item :command= "zh_CN_number">{{zh_CN}}</el-dropdown-item>
   </el-dropdown-menu>
      </el-dropdown>-->
      
      <el-dropdown @command="getValue" trigger="click" szie="mini" placement='bottom'>
        <span class="el-dropdown-link" style="color:#fff;cursor: pointer">{{number}}</span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="item in languageOptions"
            :key="item.number"
            :command="item.number"
          >{{item.name}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="zhezhao" id="zhezhao"></div>
    <!-- 注册弹框 -->
    <div v-if="show1" id="layer" class="layer">
      <transition name="nameoftransition1">
        <iframe :src="zcUrl" frameborder="no" scrolling="no" class="syzcshow"></iframe>
      </transition>
      <a
        href="#"
        v-on:click="show1 = !show1"
        class="syzcshowdiv1"
        id="syzcshowdiv1"
        @click="closeIframe()"
      >
        <img src="img/close.png" />
      </a>
    </div>

    <!-- 注册协议弹框 -->
    <div v-if="showreg" id="layer" class="layer">
      <transition name="nameoftransition1">
        <iframe :src="zcUrl" frameborder="no" scrolling="no" class="syzcshow1"></iframe>
      </transition>
      <a
        href="#"
        v-on:click="showreg = false"
        class="syzcshowdivreg"
        id="syzcshowdivreg"
        @click="closeIframe()"
      >
        <img src="img/close.png" />
      </a>
    </div>

    <!-- 临时登录弹框 -->
    <div v-if="show2" id="layer" class="layer">
      <transition name="nameoftransition2">
        <iframe :src="wjUrl" frameborder="no" scrolling="no" class="sywjshow"></iframe>
      </transition>
      <a
        href="#"
        v-on:click="show2 = !show2"
        id="syzcshowdiv2"
        class="syzcshowdiv2"
        @click="closeIframe()"
      >
        <img src="img/close.png" />
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  data() {
    let categoryShow = JSON.parse(this.$supMainPageConfig);
    // this.theme = JSON.parse(this.$supMainPageConfig).catItemImg.info7.theme;
    var link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    //通过后台获取ico
    if (categoryShow.icon) {
      link.href = categoryShow.icon.icon || "favicon.ico";
    }
    document.getElementsByTagName("head")[0].appendChild(link);
    return {
      //多语言选项数据
      //languageOptions: categoryShow.language,
      //  languageOptions: [
      //    {name:'简体中文',number:'zh_CN'},
      //    {name:'繁体中文',number:'zh_TW'},
      //    {name:'英文',number:'en_US'},
      //  ],
      number: "简体中文",
      //接口参数
      //languageNum: "",

      // logo: JSON.parse(this.$supMainPageConfig).logo,
      // url: JSON.parse(this.$supMainPageConfig).contactInfoShow.url,
      // logurl: JSON.parse(this.$supMainPageConfig).contactInfoShow.logurl,
      // styles: this.theme,
      // syzcName: categoryShow.topMenuItem[0].name,
      // sywjName: categoryShow.topMenuItem[1].name,
      // loginName: categoryShow.topMenuItem[2].name,
      // //注册
      // syzcUrl: categoryShow.topMenuItem[0].url,
      // //注册状态查询
      // sywjUrl: categoryShow.topMenuItem[1].url,
      // //登录
      // urls: categoryShow.topMenuItem[2].url,
      show1: false,
      show2: false,
      showreg: false,
      zcUrl: "",
      wjUrl: "",
      langNumber: "zh_CN",
      opentype: ""
    };
  },
  //多语言刷新
  // props:{
  //       add:{
  //           type: Function
  //       }
  //   },

  created() {
    this.number = localStorage.getItem("command")
      ? this.languageOptions.filter(
          item => item.number === localStorage.getItem("command")
        )[0].name
      : "简体中文";
    //监听iframe
    window.addEventListener("message", eve => {
      if (
        eve.data.length == 98 ||
        eve.data.length == 97 ||
        eve.data.length == 99
      ) {
        document.getElementById("zhezhao").style.display = "none";
        document.body.style.overflowY = "scroll";
        this.show1 = false;
        this.show2 = false;
        this.showreg = false;
      } else {
        // 去掉云之家图标
        if (
          eve.data.length > 1 &&
          eve.data.length != 97 &&
          eve.data.length != 98
        ) {
          this.init();
        }
      }
    });
  },
  mounted() {
    //监听iframe
    window.addEventListener("message", eve => {
      if (eve.source == undefined) {
        document.getElementById("zhezhao").style.display = "none";
        document.body.style.overflowY = "scroll";
        this.show1 = false;
        this.show2 = false;
      } else {
        this.init(eve);
      }
    });
    //把登录 注册地址 放入浏览器缓存
    if (this.syzcUrl != null) {
      sessionStorage.setItem("zcUrl", this.syzcUrl);
      this.zcUrl = sessionStorage.getItem("zcUrl");
    }

    if (this.syzcregUrl != null) {
      if (this.syzcregUrl.length > 0) {
        sessionStorage.setItem("zcUrl", this.syzcregUrl);
        this.zcUrl = sessionStorage.getItem("zcUrl");
      }
    }

    this.opentypefun();
    if (this.opentype == "1") {
      this.show1 = true;
      sessionStorage.setItem("zcUrl", this.syzcUrl);
      this.zcUrl = sessionStorage.getItem("zcUrl") + "&agree=true";
      this.noneshow();
    }

    if (this.sywjUrl != null) {
      sessionStorage.setItem("wjUrl", this.sywjUrl);
      this.wjUrl = sessionStorage.getItem("wjUrl");
    }
    //把选择语种放入浏览器缓存
    // if(this.number != null){
    //    sessionStorage.setItem("number", this.number);
    //    this.number = sessionStorage.getItem("number");
    // }
  },

  methods: {
    ...mapMutations(["setI18n"]),
    //   async getValue(number) {
    //   if(this.number != null){
    //   sessionStorage.setItem("langNumber", this.number);
    //   this.number = sessionStorage.getItem("langNumber");
    // }
    //   this.$i18n.locale = number;
    //    console.log(this.$api);
    //   await this.$api.mainpageApi.getMainPageConfig(number);

    //   await this.$api.mainpageApi.getMainPageConfig(number);
    // },

    //切换语言
    //number = sessionStorage.getItem("number"),
    getValue: function(command) {
      this.number = this.languageOptions.filter(
        item => item.number === command
      )[0].name;
      this.$i18n.locale = command;
      localStorage.setItem("command", command);
      console.log(this.$i18n);
      console.log(this.$api);
      console.log(this.add);
      this.$api.mainpageApi.getMainPageConfig(command).then(response => {
        this.$api.mainpageApi.getMainPageConfig().then(response => {
          //this.$forceUpdate();
          console.log("store1", response.data.data);
          this.$supMainPageConfig = response.data.data;
          this.$store.commit("setI18n", response.data.data);
              //首页门户标签
          document.title= this.htmltitle;
          localStorage.setItem('htmlTitle', this.htmltitle);
          //  this.add();
        });
      });
      //window.location.reload()
      //   if(this.number != null){
      //   sessionStorage.setItem("langNumber", this.number);
      //   this.number = sessionStorage.getItem("langNumber");
      // }
    },

    init(e) {
      // 去掉云之家图标
      let trayMenu = document
        .getElementById("layer")
        .children[0].contentWindow.document.getElementById(
          "_TrayMenu_"
        );
      if (trayMenu){
        trayMenu.style.display = "none";
      }else{
        //有时候会出现设置云之家图标隐藏的时候，云之家图标的dom结构还没有加载出来的问题，所以这里做一个定时器来处理这个隐藏的事情
           let counter = 0
           const timer = setInterval(() => {
              if (counter > 20) {
                clearInterval(timer)
              };
             let trayMenu = document.getElementById("layer").children[0].contentWindow.document.getElementById("_TrayMenu_");
              if (trayMenu){
                 trayMenu.style.display = "none";
              }
              counter++;
            }, 500)
      }     
    },
    
    opentypefun() {
      var query_url = window.location.href;
      var dz_url = query_url.split("#")[0];
      var cs = dz_url.split("?")[1];
      var cs_arr = cs.split("&");
      var cs = {};
      for (var i = 0; i < cs_arr.length; i++) {
        cs[cs_arr[i].split("=")[0]] = cs_arr[i].split("=")[1];
      }
      this.opentype = cs.opentype;
    },

    regclick() {
      if (this.syzcregUrl != null) {
        if (this.syzcregUrl.length > 0) {
          sessionStorage.setItem("zcUrl", this.syzcregUrl);
          this.zcUrl = sessionStorage.getItem("zcUrl");
          this.showreg = true;
        } else {
          sessionStorage.setItem("zcUrl", this.syzcUrl);
          this.zcUrl = sessionStorage.getItem("zcUrl");
          this.show1 = true;
        }
      } else {
        sessionStorage.setItem("zcUrl", this.syzcUrl);
        this.zcUrl = sessionStorage.getItem("zcUrl");
        this.show1 = true;
      }
    },
    addLogin() {
      window.open(this.urls, "_blank");
    },
    closeIframe() {
      document.getElementById("zhezhao").style.display = "none";
      document.body.style.overflowY = "scroll";
    },
    noneshow() {
      document.getElementById("zhezhao").style.display = "block";
      document.body.style.overflowY = "hidden";
    }
  },

  computed: {
    ...mapGetters(["supMainPageConfig"]),

    languageOptions: function() {
      return JSON.parse(this.supMainPageConfig).language;
    },
    logo: function() {
      return JSON.parse(this.supMainPageConfig).logo;
    },
    url: function() {
      return JSON.parse(this.supMainPageConfig).contactInfoShow.url;
    },
    logurl: function() {
      return JSON.parse(this.supMainPageConfig).contactInfoShow.logurl;
    },
    styles: function() {
      return JSON.parse(this.supMainPageConfig).catItemImg.info7.theme;
    },
    syzcName: function() {
      return JSON.parse(this.supMainPageConfig).topMenuItem[0].name;
    },
    sywjName: function() {
      return JSON.parse(this.supMainPageConfig).topMenuItem[1].name;
    },

    loginName: function() {
      return JSON.parse(this.supMainPageConfig).topMenuItem[2].name;
    },
    syzcUrl: function() {
      return JSON.parse(this.supMainPageConfig).topMenuItem[0].registurl;
    },
    syzcregUrl: function() {
      return JSON.parse(this.supMainPageConfig).topMenuItem[0].registhelpurl;
    },
    sywjUrl: function() {
      return JSON.parse(this.supMainPageConfig).topMenuItem[1].url;
    },
    urls: function() {
      return JSON.parse(this.supMainPageConfig).topMenuItem[2].url;
    },
    htmltitle: function() {
      return JSON.parse(this.supMainPageConfig).constant.htmltitle;
    },


    logoStyle: function() {
      let logoConfig = JSON.parse(this.$supMainPageConfig).logo.imgUrl;
      return {
        backgroundImage: "url(" + logoConfig + ")",
        backgroundRepeat: "round",
        height: "41px",
        width: "124px"
      };
    },

    multilingual: function() {
      return {
        width: "102px !im",
        height: "38px !im",
        background:
          "linear-gradient(90deg,rgba(129, 201, 255, 1) 0%,rgba(74, 152, 255, 1) 100%)",
        borderRadius: "4px",
        border: "none",
        color: "#ffffff",
        marginLeft: "0px",
        cursor: "pointer"
      };
    },

    login: function() {
      if (this.styles == 1) {
        return {
          width: "90px",
          height: "38px",
          background:
            "linear-gradient(90deg,rgba(129, 201, 255, 1) 0%,rgba(74, 152, 255, 1) 100%)",
          borderRadius: "4px",
          border: "none",
          color: "#ffffff",
          marginLeft: "20px",
          cursor: "pointer"
        };
      }
      if (this.styles == 2) {
        return {
          width: "90px",
          height: "38px",
          background: "linear-gradient( 90deg, #6869FB 0%,#6869FB 100%)",
          borderRadius: "4px",
          border: "none",
          color: "#ffffff",
          marginLeft: "20px",
          cursor: "pointer"
        };
      }
      if (this.styles == 3) {
        return {
          width: "90px",
          height: "38px",
          background: "linear-gradient( 90deg, #29C392 0%,#29C392 100%)",
          borderRadius: "4px",
          border: "none",
          color: "#ffffff",
          marginLeft: "20px",
          cursor: "pointer"
        };
      }
      if (this.styles == 4) {
        return {
          width: "90px",
          height: "38px",
          background: "linear-gradient( 90deg, #FC8555 0%,#FC8555 100%)",
          borderRadius: "4px",
          border: "none",
          color: "#ffffff",
          marginLeft: "20px",
          cursor: "pointer"
        };
      }
    }
  }
};
</script>

<style scoped lang="scss">
.left {
  display: flex;
  margin-top: 10px;
  align-items: center;
  float: left;
}
.topa {
  display: flex;
  margin-top: 13px;
  align-items: center;
  float: right;
}
.centerBox {
  width: 100%;
  align-items: center;
}
.leftitem {
  display: flex;
  top: 4%;
  bottom: 0;
  position: absolute;
  align-items: center;
}
.leftitem .supgate {
  padding-left: 10px;
  font-size: 14px;
  color: #ffffff;
  white-space: nowrap;
  line-height: 41px;
}

.supgate {
  padding-left: 10px;
  font-size: 14px;
  color: #ffffff;
  white-space: nowrap;
  line-height: 41px;
}

.rightitem {
  display: flex;
  justify-content: flex-end;
  margin-right: 390px;
}

//过渡动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.syzcshow {
  z-index: 10;
  position: fixed;
  width: 480px;
  height: 550px;
  left: 45%;
  top: 28.5%;
  margin-left: -150px;
  margin-top: -140px;
  background-color: #ffffff;
}

.syzcshow1 {
  z-index: 10;
  position: fixed;
  width: 980px;
  height: 600px;
  left: 45%;
  top: 28.5%;
  margin-left: -350px;
  margin-top: -150px;
  background-color: #ffffff;
}

.syzcshowdivreg {
  z-index: 100;
  position: fixed;
  left: 45%;
  top: 28.5%;
  margin-left: 600px;
  margin-top: -145px;
}

.sywjshow {
  z-index: 10;
  position: fixed;
  width: 480px;
  height: 360px;
  left: 45%;
  top: 28.5%;
  margin-left: -150px;
  margin-top: -140px;
  background-color: #ffffff;
}

.syzcshowdiv1 {
  z-index: 100;
  position: fixed;
  left: 45%;
  top: 28.5%;
  margin-left: 295px;
  margin-top: -120px;
}

.syzcshowdiv2 {
  z-index: 100;
  position: fixed;
  left: 45%;
  top: 28.5%;
  margin-left: 295px;
  margin-top: -120px;
}

.zhezhao {
  width: 100%;
  height: 100%;
  background-color: #000;
  filter: alpha(opacity=50);
  -moz-opacity: 0.5;
  opacity: 0.5;
  position: fixed;
  left: 0px;
  top: 0px;
  display: none;
  z-index: 5;
}

.column {
  margin-left: 20px;
  color: #ffffff;
}

//设置多语言边距
.login {
  margin-right: 20px;
  color: #ffffff;
}
.language::v-deep .el-input__inner {
  height: 38px;
  width: 105px;
}
.register {
  color: #ffffff;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 20px;
  text-decoration: none;
}

.forget {
  color: #ffffff;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 20px;
  margin-left: 20px;
  text-decoration: none;
}
</style>
